
/**
 * 从JSON数据中把null值过滤掉。支持过滤数组，null,NA
 * @author Huanping Zhang
 * @since 2019-08-13
 */
function removeEmpty( searchParameters ){
  	
    for( var prop in searchParameters ){
		if( searchParameters[prop] && searchParameters[prop].length == 0 ){
			searchParameters[prop] = null;
		}
	}
	
	let spString = JSON.stringify( searchParameters );
	spString = spString.replace(/\"\"/g, "null");
	spString = spString.replace(/:[\s]*null/gi, ":NA");
	spString = spString.replace(/null[\s]*,/gi, "");
	spString = spString.replace(/null[\s]*\]/gi, "]");
	spString = spString.replace(/:NA/gi, ":null");
	searchParameters = JSON.parse( spString );  
	
	return searchParameters;
}

/**
 * 将JSON数组转换为 URI encode的字符串。可以用于 header和 get 的参数传递
 * @author Huanping Zhang
 * @since 2019-08-13
 */
function  json2EncodeString( jsonParameters ){

    let searchParameters = removeEmpty( jsonParameters );
    
    let queryString = JSON.stringify( searchParameters );
		
    return encodeURIComponent( queryString );
}

/**
 * 将URI encode的字符串，转回Json对象。
 * @author Huanping Zhang
 * @since 2019-08-13
 */
function  encodeString2Json( encodeString ){

    let jsonString = decodeURIComponent( encodeString );
    
    let json = JSON.parse( jsonString );
		
    return json;
}


export default {
    removeEmpty,
    json2EncodeString,
    encodeString2Json  
}
